import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Login2 from '@/components/Login2'
import Index from '@/components/Index'
import Product from '@/components/Product'
import Add from '@/components/Add'
import Model_list from '@/components/Model_list'

import BindWeChat from '@/components/BindWeChat'
import LoginWeChat from '@/components/LoginWeChat'
import Model_creat from '@/components/Model_creat'
import Center from '@/components/Center'
import Feedback from '@/components/Feedback'
import Company from '@/components/Company'
import Store from '@/components/Store'
import Password from '@/components/Password'
import Video from '@/components/Video'
import Weather from '@/components/Weather'
import weatherTime from '@/components/weatherTime'
import Search from '@/components/Search'
import Complain_info from '@/components/Complain_info'
import Common_introduce from '@/components/Common_introduce'
import Common_product from '@/components/Common_product'
import Common_scan from '@/components/Common_scan'
import Common_video from '@/components/Common_video'
import Common_drew from '@/components/Common_drew'
import test from '@/components/test'
import us from '@/components/us'

import Communication from '@/components/Communication'

import Main from '@/views/Main'


//执法平台
// import lawLogin from '@/components/gateway-login'
// import lawIndex from '@/components/gateway-index'
// import lawMy from '@/components/gateway-my'
// import lawMyPassword from '@/components/gateway-my-password'
// import lawRecordList from '@/components/gateway-record-list'
// import lawRecordDetails from '@/components/gateway-record-details'
// import lawCollect from '@/components/gateway-collect'
//end

//植物识别
import online from '@/components/online'
import onlineMy from '@/components/online-my'
import onlineDetails from '@/components/online-details'
//end

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [{
      path: '/',
      // redirect:'Search',
      name: 'Search',
      component: Search
    },
    {
      path: '/Search',
      // redirect:'Search',
      name: 'Search',
      component: Search
    },
    //公共服务平台首页
    {
      path: '/q/:num',
      name: 'Search',
      component: Search
    },
    //新闻详情
    {
      path: '/newsDetails',
      name: 'newsDetails',
      component: () => import( /* webpackChunkName: "Login" */ '@/components/newsDetails.vue')
    },
    //设备信息
    {
      path: '/DeviceInfo',
      name: 'DeviceInfo',
      component: () => import( /* webpackChunkName: "Login" */ '@/components/DeviceInfo.vue')
    },
    //关联设备
    {
      path: '/CodeJoin',
      name: 'CodeJoin',
      component: () => import( /* webpackChunkName: "Login" */ '@/components/CodeJoin.vue')
    },
    //投诉建议
    {
      path: '/Complain_info',
      name: 'Complain_info',
      component: Complain_info
    },
    //公共服务平台企业介绍
    {
      path: '/Common_introduce',
      name: 'Common_introduce',
      component: Common_introduce
    },
    //公共服务平台产品
    {
      path: '/Common_product',
      name: 'Common_product',
      component: Common_product
    },
    //公共服务平台产品
    {
      path: '/Common_scan',
      name: 'Common_scan',
      component: Common_scan
    },
    //公共服务平台数据监控
    {
      path: '/Common_video',
      name: 'Common_video',
      component: Common_video
    },
    // {
    //   path: '/Common_drew',
    //   name: 'Common_drew',
    //   component: Common_drew
    // },
    //公共服务平台数据监控
    {
      path: '/BindWeChat',
      name: 'BindWeChat',
      component: BindWeChat
    },

    {
      path: '/LoginWeChat',
      name: 'LoginWeChat',
      component: LoginWeChat
    },
    //讲师注册
    {
      path: '/us',
      name: 'us',
      component: us,
      meta: {
        title: '惠农商学院特聘师资信息登记表'
      },
      beforeEnter: (to, from, next) => {
        if (to.meta && to.meta.title) {
          document.title = to.meta.title;
        }
        next();
      }
    },
    // 企业版
    {
      path: '/',
      name: 'Main',
      component: Main,
      children: [{
          path: '/',
          name: 'Main',
          component: Main,
        },
        // 企业介绍
        {
          path: '/Index',
          name: 'Index',
          component: Index,
          meta: {
            title: '企业介绍',
            subTitle: ''
          }
        },
        // 实时监控
        {
          path: '/Video',
          name: 'Video',
          component: Video,
          meta: {
            title: '实时监控',
            subTitle: ''
          }
        },
        // 产品列表 产品列表
        {
          path: '/Product',
          name: 'Product',
          component: Product,
          meta: {
            title: '产品列表',
            subTitle: ''
          }
        },
        //网店
        {
          path: '/Store',
          name: 'Store',
          component: Store,
          meta: {
            title: '网店配置',
            subTitle: '网店地址管理'
          }
        },
        {
          path: '/Center',
          name: 'Center',
          component: Center,
          meta: {
            title: '企业信息',
            subTitle: ''
          }
        },
        //反馈
        {
          path: '/Feedback',
          name: 'Feedback',
          component: Feedback,
          meta: {
            title: '反馈信息',
            subTitle: '反馈信息'
          }
        },
        // 产品管理
        {
          path: '/ProductManage',
          name: 'ProductManage',
          component: () => import('@/components/ProductManage.vue'),
          meta: {
            title: '产品管理',
            subTitle: '产品管理'
          }
        },
        // 编辑产品信息
        {
          path: '/EditProduct',
          name: 'EditProduct',
          component: () => import('@/components/EditProduct.vue'),
          meta: {
            title: '编辑产品信息',
            subTitle: '编辑产品信息'
          }
        },
        // 查看批次
        {
          path: '/ViewBatch',
          name: 'ViewBatch',
          component: () => import('@/components/ViewBatch.vue'),
          meta: {
            title: '批次信息',
            subTitle: '批次信息'
          }
        },
        // 批次管理
        {
          path: '/BatchManage',
          name: 'BatchManage',
          component: () => import('@/components/BatchManage.vue'),
          meta: {
            title: '批次信息',
            subTitle: '批次信息'
          }
        },
        // 添加溯源信息
        {
          path: '/AddSource',
          name: 'AddSource',
          component: () => import('@/components/AddSource.vue'),
          meta: {
            title: '添加溯源信息',
            subTitle: '添加溯源信息'
          }
        },
        // 品牌管理
        {
          path: '/BrandManage',
          name: 'BrandManage',
          component: () => import('@/components/BrandManage.vue'),
          meta: {
            title: '品牌管理',
            subTitle: '品牌管理'
          }
        },
        // 修改企业信息
        {
          path: '/Company',
          name: 'Company',
          component: () => import('@/components/Company.vue'),
          meta: {
            title: '修改企业信息',
            subTitle: '修改企业信息'
          }
        },
        {
          path: '/AloneCodeJoin',
          name: 'AloneCodeJoin',
          component: () => import('@/components/AloneCodeJoin.vue'),
          meta: {
            title: '单码关联',
            subTitle: '单码关联'
          }
        },
        {
          path: '/FullCodeJoin',
          name: 'FullCodeJoin',
          component: () => import('@/components/FullCodeJoin.vue'),
          meta: {
            title: '整批关联',
            subTitle: '整批关联'
          }
        },
        {
          path: '/SegmentCodeJoin',
          name: 'SegmentCodeJoin',
          component: () => import('@/components/SegmentCodeJoin.vue'),
          meta: {
            title: '号段关联',
            subTitle: '号段关联'
          }
        },
        //修改密码
        {
          path: '/Password',
          name: 'Password',
          component: Password,
          meta: {
            title: '修改密码',
            subTitle: '修改密码'
          }
        },
        //添加流通记录
        {
          path: '/Communication',
          name: 'Communication',
          component: Communication,
          meta: {
            title: '添加流通记录',
            subTitle: '添加流通记录'
          }
        },

      ]
    },

    // //网店
    // {
    //   path: '/Store',
    //   name: 'Store',
    //   component: Store,
    //   meta: {
    //     title: '网店配置',
    //     subTitle: '网店地址管理'
    //   }
    // },
    // // 企业介绍
    // {
    //   path: '/Index',
    //   name: 'Index',
    //   component: Index
    // },
    // {
    //   path: '/Center',
    //   name: 'Center',
    //   component: Center
    // },

    // 产品列表 添加产品
    {
      path: '/Add',
      name: 'Add',
      component: Add
    },
    // 产品列表 添加溯源
    {
      path: '/Model_list',
      name: 'Model_list',
      component: Model_list
    },
    {
      path: '/Model_creat',
      name: 'Model_creat',
      component: Model_creat
    },


    //气象数据
    {
      path: '/Weather',
      name: 'Weather',
      component: Weather
    },
    //实时天气
    {
      path: '/weatherTime',
      name: 'weatherTime',
      component: weatherTime
    },
    //测试
    {
      path: '/test',
      name: 'test',
      component: test
    },
    //登录
    {
      path: '/Login',
      name: 'Login',
      component: () => import( /* webpackChunkName: "Login" */ '@/components/Login.vue')
    },
    //新版登录
    {
      path: '/Login2',
      name: 'Login2',
      component: () => import( /* webpackChunkName: "Login" */ '@/components/Login2.vue')
    },
    // //执法平台-登录
    // {
    //   path: '/gateway-login',
    //   name: 'lawLogin',
    //   component: () => import('@/components/gateway-login.vue')
    // },
    // //执法平台-首页
    // {
    //   path: '/gateway-index',
    //   name: 'lawIndex',
    //   component: () => import('@/components/gateway-index.vue')
    // },
    // //执法平台-我的
    // {
    //   path: '/gateway-my',
    //   name: 'lawMy',
    //   component: () => import('@/components/gateway-my.vue')
    // },
    // //执法平台-我的-修改密码
    // {
    //   path: '/gateway-my-password',
    //   name: 'lawMyPassword',
    //   component: () => import('@/components/gateway-password.vue')
    // },
    // //执法平台-执法记录列表
    // {
    //   path: '/gateway-record-list',
    //   name: 'lawRecordList',
    //   component: () => import('@/components/gateway-record-list.vue')
    // },
    // //执法平台-执法记录列表
    // {
    //   path: '/gateway-record-details',
    //   name: 'lawRecordDetails',
    //   component: () => import('@/components/gateway-record-details.vue')
    // },
    // //执法平台-执法记录列表
    // {
    //   path: '/gateway-collect',
    //   name: 'lawCollect',
    //   component: () => import('@/components/gateway-collect.vue')
    // },
    //在线问答
    {
      path: '/online',
      name: 'online',
      component: () => import('@/components/online.vue')
    },
    //我的在线问答
    {
      path: '/online-my',
      name: 'onlineMy',
      component: () => import('@/components/online-my.vue')
    },
    //问答详情
    {
      path: '/online-details',
      name: 'onlineDetails',
      component: () => import('@/components/online-details.vue')
    },

  ]
})

router.beforeEach((to, form, next) => {
  /*路由变化修改title*/
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }
  next();
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js